import { Controller } from "@hotwired/stimulus"
import { Chart, LineController, LineElement, PointElement, Filler, CategoryScale, LinearScale, Tooltip } from "chart.js"

Chart.register(LineController, LineElement, PointElement, Filler, CategoryScale, LinearScale, Tooltip)

function getOrCreateTooltip(chart) {
  let el = chart.canvas.parentNode.querySelector(".chart-tooltip")
  if (!el) {
    el = document.createElement("div")
    el.classList.add("chart-tooltip")
    chart.canvas.parentNode.appendChild(el)
  }
  return el
}

export default class extends Controller {
  static targets = ["canvas"]
  static values = {
    points: Array,
    label: { type: String, default: "Volume (kg)" }
  }

  connect() {
    if (this.pointsValue.length === 0) return

    const labels = this.pointsValue.map(p => p.date)
    const data = this.pointsValue.map(p => p.value)
    const points = this.pointsValue
    const labelText = this.labelValue

    this.hideTooltip = (event) => {
      if (!this.chart.canvas.contains(event.target)) {
        const el = this.chart.canvas.parentNode.querySelector(".chart-tooltip")
        if (el) el.style.opacity = "0"
        this.chart.setActiveElements([])
        this.chart.tooltip.setActiveElements([], { x: 0, y: 0 })
        this.chart.update()
      }
    }
    document.addEventListener("click", this.hideTooltip)

    this.chart = new Chart(this.canvasTarget, {
      type: "line",
      data: {
        labels: labels,
        datasets: [{
          data: data,
          borderColor: "#C5630C",
          backgroundColor: "rgba(197, 99, 12, 0.1)",
          fill: true,
          tension: 0.3,
          pointBackgroundColor: "#C5630C",
          pointRadius: 4,
          pointHoverRadius: 6
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: false },
          tooltip: {
            enabled: false,
            external: (context) => {
              const { chart, tooltip } = context
              const tooltipEl = getOrCreateTooltip(chart)

              if (tooltip.opacity === 0) {
                tooltipEl.style.opacity = "0"
                return
              }

              const dataIndex = tooltip.dataPoints[0].dataIndex
              const point = points[dataIndex]

              let bodyHtml = ""

              if (point.sessions && point.sessions.length > 0) {
                point.sessions.forEach(session => {
                  bodyHtml += `<div class="chart-tooltip-session">`
                  bodyHtml += `<div class="chart-tooltip-date">${session.date}</div>`
                  bodyHtml += `<div class="chart-tooltip-sets">`
                  session.sets.forEach(s => {
                    bodyHtml += `<div class="chart-tooltip-set"><span class="chart-tooltip-num">${s.num}</span>${s.text}</div>`
                  })
                  bodyHtml += `</div></div>`
                })
              } else {
                bodyHtml = `<div class="chart-tooltip-empty">Sem treino</div>`
              }

              const unitLabel = labelText.includes("reps") ? "reps" : "kg"

              tooltipEl.innerHTML = `
                <div class="chart-tooltip-header">Semana ${point.date}</div>
                ${bodyHtml}
                <div class="chart-tooltip-total">${point.value} ${unitLabel}</div>
              `

              const { offsetLeft, offsetTop } = chart.canvas
              tooltipEl.style.opacity = "1"
              tooltipEl.style.left = offsetLeft + tooltip.caretX + "px"
              tooltipEl.style.top = offsetTop + tooltip.caretY + "px"
            }
          }
        },
        scales: {
          x: {
            grid: { display: false },
            ticks: { font: { size: 11 }, color: "#425466" }
          },
          y: {
            beginAtZero: true,
            grid: { color: "rgba(0,0,0,0.05)" },
            ticks: { font: { size: 11 }, color: "#425466" }
          }
        }
      }
    })
  }

  disconnect() {
    if (this.hideTooltip) {
      document.removeEventListener("click", this.hideTooltip)
    }
    if (this.chart) {
      this.chart.destroy()
      this.chart = null
    }
  }
}
